import React, { useState } from "react";

const PRO_PASSWORD = "%3YVM%+V$y2EwEG"; // Replace with a better secret for production

// Mock client data and explainable ML results
const clients = [
  {
    id: 1,
    name: "Alex Smith",
    results: [
      { date: "2025-07-04", risk: 0.72, topFeatures: ["pitch", "energy"] },
      { date: "2025-07-03", risk: 0.60, topFeatures: ["tempo", "jitter"] }
    ]
  },
  {
    id: 2,
    name: "Maria Lopez",
    results: [
      { date: "2025-07-04", risk: 0.33, topFeatures: ["energy"] }
    ]
  }
];

export default function TherapistDashboard() {
  const [unlocked, setUnlocked] = useState(false);
  const [input, setInput] = useState("");
  const [selected, setSelected] = useState(clients[0].id);
  const [notes, setNotes] = useState({});
  const [showRiskInfo, setShowRiskInfo] = useState(false);

  if (!unlocked) {
    return (
      <div style={{ textAlign: "center", marginTop: 40 }}>
        <h2>🔒 Pro Therapist Dashboard</h2>
        <input
          type="password"
          placeholder="Enter Pro password"
          value={input}
          onChange={e => setInput(e.target.value)}
          style={{ marginRight: 8 }}
        />
        <button
          onClick={() => {
            if (input === PRO_PASSWORD) setUnlocked(true);
            else alert("Incorrect password");
          }}
        >
          Unlock
        </button>
      </div>
    );
  }

  const client = clients.find(c => c.id === selected);

  return (
    <div style={{ padding: 24, maxWidth: 520, margin: "0 auto" }}>
      <h2>Therapist Dashboard (Pro)</h2>
      <label style={{ fontWeight: 600 }}>
        Select client:{" "}
        <select value={selected} onChange={e => setSelected(Number(e.target.value))}>
          {clients.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </label>

      <h3 style={{ marginTop: 24 }}>Explainable AI Risk Results</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 16 }}>
        <thead>
          <tr>
            <th>Date</th>
            <th>
              Risk Score{" "}
              <span
                style={{ cursor: "pointer", color: "#888" }}
                aria-label="What is risk score?"
                title="What is risk score?"
                onClick={() => setShowRiskInfo(true)}
              >
                ℹ️
              </span>
              {showRiskInfo && (
                <div
                  style={{
                    position: "absolute",
                    background: "#fff",
                    color: "#222",
                    border: "1px solid #ccc",
                    borderRadius: 8,
                    padding: 12,
                    width: 320,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                    zIndex: 1000,
                    marginTop: 8,
                  }}
                  role="dialog"
                  aria-modal="true"
                  tabIndex={-1}
                >
                  <strong>What is a Risk Score?</strong>
                  <p style={{ fontSize: 14, margin: "8px 0" }}>
                    The risk score is an estimate (0–100%) of how likely a client is to be above a clinical threshold for a mental health condition (e.g., depression, anxiety), based on machine learning analysis of their speech and behavioral data. Higher scores indicate higher predicted risk. Top features show which aspects of the data contributed most to the risk estimate.
                  </p>
                  <button
                    style={{
                      marginTop: 6,
                      padding: "4px 16px",
                      borderRadius: 8,
                      background: "#FFD166",
                      border: "none",
                      fontWeight: 600,
                      cursor: "pointer"
                    }}
                    onClick={() => setShowRiskInfo(false)}
                  >
                    Close
                  </button>
                </div>
              )}
            </th>
            <th>Top Features</th>
          </tr>
        </thead>
        <tbody>
          {client.results.map((r, i) => (
            <tr key={i}>
              <td>{r.date}</td>
              <td>{(r.risk * 100).toFixed(1)}%</td>
              <td>{r.topFeatures.join(", ")}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>Session Notes</h3>
      <textarea
        placeholder="Add session notes..."
        style={{
          width: "100%",
          minHeight: 60,
          borderRadius: 8,
          border: "1px solid #ccc",
          padding: 8,
          marginBottom: 12
        }}
        value={notes[selected] || ""}
        onChange={e => setNotes({ ...notes, [selected]: e.target.value })}
      />
    </div>
  );
}
